import {
  Content,
  Panel,
  PanelContainer,
  SubHeading,
} from "@src/Components/Common"
import { Link } from "@src/Components/Link"
import Tooltip from "@src/Components/Tooltip"
import { colors } from "@src/theme"
import { Typography } from "@zeguro/component-library"
import { Button } from "@zeguro/component-library"
import * as React from "react"

import MessageContainer from "../../../MessageContainer"
import {
  ButtonContainer,
  FooterText,
  HeadingGray,
  Icon,
  ResponsiveHeading,
  Row,
} from "./styles"

export type tOnSubmit = (data: any) => void

interface IVerifyEmail {
  height: number
  emailToVerify: string
  isResendDisabled: boolean
  resendTooltip: string
  onVerifyEmail: (username: string) => void
  showSupportModal: () => void
  redirectToSignup: () => void
}

const VerifyEmail = ({
  height,
  emailToVerify,
  isResendDisabled,
  resendTooltip,
  onVerifyEmail,
  showSupportModal,
  redirectToSignup,
}: IVerifyEmail) => {
  const goToSignupScreen = () => {
    redirectToSignup()
  }

  const resendVerificationCode = () => {
    onVerifyEmail(emailToVerify)
  }

  return (
    <Content height={height}>
      <MessageContainer />
      <PanelContainer height={height}>
        <Panel>
          <Row>
            <ResponsiveHeading>
              <Typography
                variant="heading1"
                color={colors.darkBlue}
                align="center"
                margin="20px 0px"
              >
                Verify your email.
              </Typography>
            </ResponsiveHeading>
          </Row>
          <Row>
            <SubHeading>
              Check your email
              <span
                dangerouslySetInnerHTML={{
                  __html:
                    emailToVerify && emailToVerify !== ""
                      ? ` at <b>${emailToVerify}</b>`
                      : "",
                }}
              />
              &nbsp;and click the link to activate your account.
            </SubHeading>
          </Row>
          <Row>
            <Icon src="images/icon_email_verified.svg" />
          </Row>
          <br />
          <Row>
            <HeadingGray>Didn&apos;t receive an email?</HeadingGray>
          </Row>
          <Row>
            <SubHeading>
              It may take a couple of minutes to arrive in your inbox. Please
              check your spam or junk folder if you don&apos;t see it.
            </SubHeading>
          </Row>
          <Row>
            <ButtonContainer>
              <Button
                variant="secondary"
                onClick={resendVerificationCode}
                id="resend-email-button"
                width="190px"
                margin="10px"
                disabled={isResendDisabled}
                data-tooltip-id={
                  isResendDisabled ? "resend-email-tooltip" : undefined
                }
                style={{
                  opacity: isResendDisabled ? 0.6 : 1,
                  cursor: isResendDisabled ? "not-allowed" : "pointer",
                }}
              >
                Resend Email
              </Button>
              {isResendDisabled && (
                <Tooltip
                  id="resend-email-tooltip"
                  content={<p>{resendTooltip}</p>}
                  width="300px"
                  place="top"
                />
              )}
              <Button
                variant="secondary"
                onClick={showSupportModal}
                id="contact-support-button"
                width="190px"
                margin="10px"
              >
                Contact Support
              </Button>
            </ButtonContainer>
          </Row>
          <Row>
            <FooterText>
              Or&nbsp;
              <Link onClick={goToSignupScreen}>
                use another email address instead.
              </Link>
            </FooterText>
          </Row>
        </Panel>
      </PanelContainer>
    </Content>
  )
}

export default VerifyEmail
